/**
 * Labstep
 *
 * @module components/Group/Action/ManagePermissions
 * @desc Update workspace permissions per user
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { Button } from 'labstep-web/core/Button';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import type React from 'react';
import { GroupActionManageMembersTable } from './Table';
import type { GroupActionManageMembersProps } from './types';

export const GroupActionManageMembers: React.FC<
  GroupActionManageMembersProps
> = ({ group, iconOnly, actionComponentProps }) => {
  return (
    <ModalDefault
      header={`Manage Members: ${group.name}`}
      size="large"
      content={() => <GroupActionManageMembersTable group={group} />}
      viewComponent={({ toggleModal }) => {
        return iconOnly ? (
          <Popup
            trigger={
              <Button icon="cog" circular onClick={toggleModal} />
            }
            content="Manage"
            size="mini"
          />
        ) : (
          <ActionComponent
            type="option"
            icon="users"
            text="Manage Members"
            {...actionComponentProps}
            onClick={toggleModal}
          />
        );
      }}
    />
  );
};
